module.exports = __webpack_public_path__ + "feebcbce18239fc3ad8dbb1af0c1acfd.svg";